'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name, value) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set(name, encodeURIComponent(value));
  var path = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
  window.history.pushState({ path: path }, '', path);
};